import { Component, OnDestroy, OnInit, forwardRef, DoCheck } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { WorkflowComponentNew } from '../../workflow-new.component';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { Subscription } from 'rxjs';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { SecurityService } from '@infrastructure/Security/SecurityService';

import { PrestacoesMorteValueObservableService } from '@infrastructure/Documents/PrestacoesPorMorteValueObserver';
import { MaskFieldsService } from '@infrastructure/MaskService/mask-fieds.service';
import { DropdownsValues} from '@infrastructure/Dropdowns/const.dropdowns'
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty } from '@infrastructure/objectUtils';
import DateHelpers from '@infrastructure/DateHelpers';

@Component({
  selector: 'deceased-identification',
  templateUrl: './deceased-identification.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => DeceasedIdentificationComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})



export class DeceasedIdentificationComponent implements OnInit, OnDestroy {

  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];

  public maritalStatusTypes: models.Options[];

  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;
  public dropListCauseOfDeath: models.Options [] = [];


  public causeOfDeathValues = DropdownsValues.dropListCauseOfDeath;

  public minDate: Date = new Date(1900, 0, 1);
  public maxDate: Date = new Date();

  constructor(private securityService: SecurityService,
    private commonDataService: CommonDataService,
    private prestacoesMorteValueObserverService: PrestacoesMorteValueObservableService,
    private maskFielsService: MaskFieldsService) {
    const domains = [
      DomainCodes.yesNo,
      DomainCodes.genders,
      DomainCodes.martialStatus,
      DomainCodes.identificationType
    ];

    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
         
          this.documentTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.identificationType).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }
  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.DeceasedIdentificationVM{
    return this._cardData;
  }
  public set cardData(value: models.DeceasedIdentificationVM) {
    this._cardData = value;
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.DeceasedIdentificationVM = {} as models.DeceasedIdentificationVM;

  public parentWorkflow: WorkflowComponentNew;

  //Este campo serve para que se os dados vierem do P21, estes não podem ser editáveis. Se não vierem, então os dados são editáveis
  public preFilledProperties: PreFilledProperty[] = [];
  private isFirstChange: boolean = true;


  ngOnInit(): void {
    this.dropListCauseOfDeath = this.parentWorkflow.workflowDropdowns.options
      .filter(el => el.dropdown === "DropdownDeathCause");

    this.maritalStatusTypes = this.parentWorkflow.workflowDropdowns.options
      .filter(el => el.dropdown === "dropListMaritalStatus");
    
    if (this.cardData.subscriberName?.toString() != null) {
      
      //Se o requerente não for funeraria então pedir certidão de nascimento de falecido

        this.prestacoesMorteValueObserverService.changeCertidaoNascimentoFalecidoNotification(
          this.parentWorkflow.workflowInstance.StepDeceased.DeceasedIdentification.subscriberName,
          this.parentWorkflow.workflowInstance.StepDeceased.DeceasedIdentification.NIF,
          true);

    }

  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

  public getMaskDate(value: Date): string {
    return this.maskFielsService.getMaskDate(value);
  }

  public getMaskNumber(value: number): string {
    return this.maskFielsService.getMaskNumber(value);

  }


  public getMaskMaritalStatus(value: string): string {
    return this.maskFielsService.getMaskMaritalStatus(value, this.maritalStatusTypes);
  }
  
  private onCardDataChanged() {

    this.addPreFilledFields();

    this.cardData.subscriberNumber = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.subscriberNumber;
    this.cardData.subscriberName = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.subscriberName;
    this.cardData.dateOfBirth = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.dateOfBirth;
    this.cardData.identificationDocumentType = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.identificationDocumentType;
    this.cardData.identificationNumberFirst = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.identificationNumberFirst;
    this.cardData.identificationNumberLast = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.identificationNumberLast;
    this.cardData.NIF = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.NIF;
    this.cardData.maritalStatus = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.maritalStatus;
    this.cardData.fatherName = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.fatherName;
    this.cardData.motherName = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.motherName;
    this.cardData.deathDate = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.deathDate;
    this.cardData.deathDateRegistered= this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.deathDateRegistered;
    this.cardData.deathCause = this.parentWorkflow.workflowInstance.StepDeceased?.DeceasedIdentification?.deathCause;

  }

  private addPreFilledFields() {
    if (this.isFirstChange) {
      this.isFirstChange = false;
      this.preFilledProperties.push({ name: "subscriberName", preFilledValue: this.cardData.subscriberName, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.subscriberName) });
      this.preFilledProperties.push({ name: "dateOfBirth", preFilledValue: this.cardData.dateOfBirth, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.dateOfBirth) });
      this.preFilledProperties.push({ name: "identificationNumberFirst", preFilledValue: this.cardData.identificationNumberFirst, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.identificationNumberFirst) });
      this.preFilledProperties.push({ name: "identificationDocumentType", preFilledValue: this.cardData.identificationDocumentType, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.identificationDocumentType) });
      this.preFilledProperties.push({ name: "nif", preFilledValue: this.cardData.NIF, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.NIF) });
      this.preFilledProperties.push(
        {
          name: "maritalStatus",
          preFilledValue: this.cardData.maritalStatus,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.maritalStatus)
        });
      this.preFilledProperties.push(
        {
          name: "fatherName",
          preFilledValue: this.cardData.fatherName,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.fatherName)
        });
      this.preFilledProperties.push(
        {
          name: "motherName",
          preFilledValue: this.cardData.motherName,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.motherName)
        });
      this.preFilledProperties.push(
        {
          name: "deathDate",
          preFilledValue: this.cardData.deathDate,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.deathDate)
        });
      this.preFilledProperties.push(
        {
          name: "deathDateRegistered",
          preFilledValue: this.cardData.deathDateRegistered,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.deathDateRegistered)
        });


    }
  }


  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    var object

    switch (event.target.name) {
      case 'deathDate': {
        object = new Date(this.cardData.deathDate).toISOString().split('T')[0];
        break;
      }
      case 'dateOfBirth': {
        object = new Date(this.cardData.dateOfBirth).toISOString().split('T')[0];
        break;
      }
      case 'deathDateRegistered': {
        object = new Date(this.cardData.deathDateRegistered).toISOString().split('T')[0];
        break;
      }
      case 'diagnosedDeathDate': {
        object = new Date(this.cardData.diagnosedDeathDate).toISOString().split('T')[0];
        break;
      }
    }

    DateHelpers.onDateChange(event, dp, object);
  }

}
